import React from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

export default class PromiseButton extends React.Component {

  constructor(props){
    super(props);
    this.state={
      disabled:false
    }
  }


  handler() {
    let handler = this.props.onClick();
    // If promise is returned disable button
    if (handler && Promise.resolve(handler)) {
    // Disable button
      this.setState({disabled: true});
      // Un-disable button after promise has resolved or rejected
      return handler.then(() => {
        return this.setState({disabled: false});
      }).catch(() => {
        return this.setState({disabled: false});
      });
    }
  }

  render(){
    return(
      <Button
        {...this.props}
        disabled={this.state.disabled || this.props.disabled}
        onClick={()=>{this.handler()}}>
        {this.state.disabled===true &&
          <Spinner as="span" size="sm" animation="border" style={{marginRight:5}}/>
        }
        {this.props.children}
      </Button>
    );
  }
}
